export default __webpack_public_path__ + "static/media/domain.346a12a2.png";